import { Box, styled, useMediaQuery, useTheme } from "@mui/material";
import { Outlet as RouterOutlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";

import SideMenuDrawer from "components/layout/Desktop/SideMenuDrawer";
import SystemAlerts from "components/SystemAlerts.js";
import TopAppBar from "components/layout/Desktop/TopAppBar";
import { getUser } from "store/slices/user/userSlice";
import { oidcUserManager } from "config/authentication";
import useDispatch from "hooks/useDispatch";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";

const drawerWidth = 210;

export default function DesktopLayout() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const isMdView = useMediaQuery(theme.breakpoints.down("lg"));
  const isUserBlocked = useIsUserBlocked();

  const [open, setOpen] = useState(isMdView ? false : true);
  const [pageLoading, setPageLoading] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setPageLoading(true);

    oidcUserManager
      .getUser()
      .then((user) => {
        if (!user) {
          navigate("/welcome");
        } else {
          dispatch(getUser());
        }
      })
      .finally(() => {
        setPageLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

  const handlePageShow = (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  };

  window.addEventListener('pageshow', handlePageShow);

  return () => {
    window.removeEventListener('pageshow', handlePageShow);
  };
}, []);

  return (
    <Box sx={{ display: "flex", background: theme.palette.background.default }}>
      {!pageLoading && (
        <>
          <TopAppBar
            drawerWidth={drawerWidth}
            open={!isUserBlocked ? open : false}
            handleDrawerOpen={handleDrawerOpen}
          />

          <SideMenuDrawer
            drawerWidth={drawerWidth}
            open={!isUserBlocked ? open : false}
            onClose={handleDrawerClose}
          />

          <Main open={!isUserBlocked ? open : false}>
            <CssBaseline />

            <SystemAlerts />

            <RouterOutlet />
          </Main>
        </>
      )}
    </Box>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(10, 0, 2),
    maxWidth: `100%`,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      maxWidth: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
      background: theme.palette.background.paper,
    }),
  })
);
